<template>
  <div
    class="components-container"
    @click.stop="clickMenuHandle"
    @touchmove.stop.prevent
    @mousewheel.stop.prevent
    v-show="menuStatus"
  >
    <div
      class="nav-content"
      @click.stop
      :class="{ active: menuAnmationStatus, childrenActive: childrenMenuList.length }"
    >
      <div class="top-area">
        <img
          class="close-icon"
          @click.stop="clickMenuHandle"
          @touchmove.stop.prevent
          @mousewheel.stop.prevent
          src="../assets/icon/14-active.png"
          alt=""
        />
      </div>
      <ul class="menu-area">
        <li
          v-for="(item, index) in navList"
          :key="index"
          @click="clickMenuItem(item.path)"
          @mouseover="mouseOver(item.children)"
          @mouseleave="mouseLeave(item.children)"
        >
          <img class="menu-icon icon-gray" :src="item.icon" alt="" />
          <img class="menu-icon icon-active" :src="item.icon_active" alt="" />
          {{ item.name }}
          <span class="arrow-icon" v-if="item.children && item.children.length">＞</span>
        </li>
      </ul>
    </div>

    <div
      class="nav-content children-content"
      @click.stop
      :class="{ active: childrenMenuList.length }"
    >
      <div class="top-area"></div>
      <ul class="menu-area flex-area">
        <li
          v-for="(item, index) in childrenMenuList"
          :key="index"
          @click="clickMenuItem(item.path)"
        >
          <img class="menu-icon menu-icon-child icon-gray" :class="{'icon-ts' : item.name == '唐彩系列' || item.name == '景福系列'}" :src="item.icon" alt="" />
          <img class="menu-icon menu-icon-child icon-active" :class="{'icon-ts' : item.name == '唐彩系列' || item.name == '景福系列'}" :src="item.icon_active" alt="" />
          {{ item.name }}
          <span class="arrow-icon" v-if="item.children && item.children.length">＞</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "comnav",
  data() {
    return {
      menuStatus: false,
      menuAnmationStatus: false,
      childrenMenuStatus: false,
      childrenMenuList: [],
      navList: [
        {
          name: "首页",
          path: "/index",
          icon: require("../assets/icon/10.png"),
          icon_active: require("../assets/icon/10-active.png"),
        },
        {
          name: "系列",
          icon: require("../assets/icon/11.png"),
          icon_active: require("../assets/icon/11-active.png"),
          children: [
            {
              name: "经典系列",
              path: "/set/1",
              icon: require("../assets/icon/1.png"),
              icon_active: require("../assets/icon/1-active.png"),
            },
            {
              name: "唐彩系列",
              path: "/set/7",
              icon: require("../assets/icon/7.png"),
              icon_active: require("../assets/icon/7-active.png"),
            },
            {
              name: "琴瑟系列",
              path: "/set/5",
              icon: require("../assets/icon/5.png"),
              icon_active: require("../assets/icon/5-active.png"),
            },
            {
              name: "麟趾系列",
              path: "/set/3",
              icon: require("../assets/icon/3.png"),
              icon_active: require("../assets/icon/3-active.png"),
            },
            {
              name: "景福系列",
              path: "/set/2",
              icon: require("../assets/icon/2.png"),
              icon_active: require("../assets/icon/2-active.png"),
            },
            {
              name: "无为系列",
              path: "/set/8",
              icon: require("../assets/icon/8.png"),
              icon_active: require("../assets/icon/8-active.png"),
            },
            {
              name: "真武系列",
              path: "/set/9",
              icon: require("../assets/icon/9.png"),
              icon_active: require("../assets/icon/9-active.png"),
            },
            {
              name: "慎独系列",
              path: "/set/6",
              icon: require("../assets/icon/6.png"),
              icon_active: require("../assets/icon/6-active.png"),
            },
            {
              name: "明德系列",
              path: "/set/4",
              icon: require("../assets/icon/4.png"),
              icon_active: require("../assets/icon/4-active.png"),
            },
          ],
        },
        {
          name: "工艺介绍",
          path: "/craft",
          icon: require("../assets/icon/12.png"),
          icon_active: require("../assets/icon/12-active.png"),
        },
        {
          name: "关于寶蘭",
          path: "/about",
          icon: require("../assets/icon/13.png"),
          icon_active: require("../assets/icon/13-active.png"),
        },
      ],
    };
  },
  mounted() {
    this.$EventBus.$on("SHOWMENU", () => {
      this.showMenuHandle();
    });
  },
  methods: {
    showMenuHandle() {
      this.menuStatus = true;
      setTimeout(() => {
        this.menuAnmation("show");
      }, 20);
    },
    clickMenuHandle() {
      this.menuAnmation();
      setTimeout(() => {
        this.menuStatus = false;
      }, 500);
    },
    clickMenuItem(path) {
      if (path) {
        this.clickMenuHandle();
        if (this.$route.fullPath != path) {
          this.$router.push(path);
        }
      }
    },
    menuAnmation(type) {
      this.menuAnmationStatus = type == "show" ? true : false;
      this.childrenMenuList = [];
    },
    mouseOver(children) {
      console.log(children)
      if (children && children.length) {
        this.childrenMenuList = children;
      }
      if (!children || !children.length) {
        this.childrenMenuList = [];
      }
    },
    mouseLeave(children) {
      if (!children || !children.length) {
        this.childrenMenuList = [];
      }
    },
  },
  destroyed() {
    this.$EventBus.$off("SHOWMENU");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.components-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  .nav-content {
    display: flex;
    flex-direction: column;
    float: left;
    height: 100%;
    width: 0px;
    // background: #ffffff;
    transition: width 0.3s;
    overflow: hidden;
    background-image: linear-gradient(180deg, #0a0020 0%, #534d63 100%);
    &.active {
      width: 250px;
    }
    &.childrenActive {
      border-right: 1px solid #555;
    }
    .top-area {
      position: relative;
      width: 100%;
      height: 150px;
      .close-icon {
        position: absolute;
        left: 20px;
        bottom: 30px;
        width: 35px;
        cursor: pointer;
      }
    }
    .menu-area {
      flex: 1;
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      &.flex-area {
        li {
          margin: 20px 0;
          padding-left: 30px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          letter-spacing: 2px;
          .menu-icon {
            width: 50px;
             &.menu-icon-child {
               height:auto;
            }
          }
        }
      }
      li {
        display: flex;
        align-items: center;
        margin: 40px 0;
        padding: 0 20px;
        font-size: 18px;
        color: #ffffff;
        white-space: nowrap;
        cursor: pointer;
        &:hover {
          color: #f4dba0;
          .icon-gray {
            display: none;
          }
          .icon-active {
            display: block;
          }
        }
        .menu-icon {
          display: none;
          margin-right: 20px;
          width: 35px;
          height: 35px;
        }
        .icon-gray {
          display: block;
        }
        .arrow-icon {
          margin-left: 80px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comnav.vue